module.exports = __webpack_public_path__ + "img/tc_scu.ac531415.png";